export default __webpack_public_path__ + "static/media/paso14.cf0283a9.png";